export enum SiteSizeEnum {
  XLarge = 'XLarge',
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

export type SiteSizeType = keyof typeof SiteSizeEnum;
